// ABOUTME: Tells the edit form fields whether the node is being created rather than edited.
// ABOUTME: In creation every content is marked inherited, so the inherited read-only rule must not apply.
import { createContext } from 'react';

export const CreateNodeContext = createContext(false);
